export default function cleanUpAuthors(authors) {
  // This regex matches the values " - Added Author" and " - Main Author", which we want to remove
  return authors?.map((author) => author.replace(/ - (added|main) author/i, ''))
}
